import React, { useState, useEffect } from 'react'
import './viewtemp.css'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { Link,useParams } from 'react-router-dom'
import BackLoader from '../../../components/backloader'
import * as Constants from '../../../constants';
import { ShareContext } from '../../../context/ShareContext'
import TopBar from '../../../components/topbar'
import { useNavigate } from 'react-router-dom'


function LiveAffidavitView() {

    const {id} = useParams(); //file id
    

  //  const linkurl=id==null?'/templates/create':
    const tempUrl= `${Constants.apiUrl}/gazette/contenliveaffidavit/${id}`;
    const [upline, setUpline]=useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [html, setHtml] =useState('');



    useEffect(() => {
        
        LoadTemplate();
        Constants.seo({title:'Affidavit',metaDescription:'Affidavit'});
    
  }, [id])

  const LoadTemplate=()=>{
    setIsLoading(true);
    fetch(tempUrl, {
        method: 'GET',
        headers: {
          'Content-type': 'application/json',
        },
      })
        .then((resp) => resp.json())
        .then((data) => {
            setIsLoading(false);

            if(data.code==0){

              setUpline(data.upline);
             // var htmlstr=atob(data.template.html);
             console.log('encode stuff');
             console.log(data.upline);
             var htmlstr=Constants.b64decode(data.upline.templateHtml);
              setHtml(htmlstr);
                
            }
            
        })
        .catch(error => {
            console.error(error);
            setIsLoading(false);
        })
}

const onPrint=()=>{
  window.print();
}

  return (
    <div className='view-temp'>
 
        <div className="body">

            <div className="doc">
                
                <div className="paper-final-doc"> <div dangerouslySetInnerHTML={{__html: html}}></div></div>
         {/*        <Link to={`/templates/${template.type}/${id}/edit`}><button className='red'>Switch to edit mode</button></Link> */}
         <button className='red no-print' onClick={onPrint}>Print/Save Document</button>
            </div>
        </div>
    </div>
  )
}

export default LiveAffidavitView